import React from 'react'

const TestimoniTableRow = ({title, content, image, ...props}) => {
  const size = '48px'

  return (
    <div className="flex" {...props}>
      <div className="mr-5">
        {image ? (
          <img
            src={image}
            alt="img"
            className="rounded-full shadow object-cover"
            style={{
              width: size,
              height: size,
              minWidth: size,
              minHeight: size,
            }}
          />
          // <div
          //   style={{width: size, height: size, backgroundImage: `url('${image}')`}}
          //   className="bg-no-repeat bg-center bg-cover rounded-full shadow"
          // />
        ) : (
          <div
            style={{ width: size, height: size, backgroundColor: "#ddd" }}
            className="rounded-full shadow"
          />
        )}
      </div>
      <div>
        <p className="font-bold text-sm mb-1">{title}</p>
        <p className="text-sm text-gray-444">{content}</p>
      </div>
    </div>
  );
}

export { TestimoniTableRow }
